
export default {
  namespaced: true,
  unit_deactivation_catalog: {
    title: "Unit Deactivation | Unit Deactivations",
    name: "Name",
    description: "Description",
    user_reactivation: "User who reactivated",
    user_deactivation: "User who deactivated",
    deactivation_reason: "Deactivation reason",
    attachments: "Attachments"
  },
};

